import React from 'react';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import theme from '@marvelapp/theme';
import App from './components/App';
import bindKeyboardShortcuts from './utils/bindKeyboardShortcuts';
import addPublicAPIs from './utils/addPublicAPIs';
import * as actionCreators from './actionCreators';
export default function createPrototypeViewer(store, _a) {
    var _b = _a === void 0 ? {} : _a, areKeyboardControlsEnabled = _b.areKeyboardControlsEnabled, _c = _b.showTouchIndicators, showTouchIndicators = _c === void 0 ? false : _c, _d = _b.isDownloaded, isDownloaded = _d === void 0 ? false : _d, _e = _b.isFrameless, isFrameless = _e === void 0 ? false : _e, _f = _b.isBasic, isBasic = _f === void 0 ? false : _f, initialScreen = _b.initialScreen, userRole = _b.userRole, companyId = _b.companyId, userIsSuperUser = _b.userIsSuperUser, userIsInHandoffTestGroup = _b.userIsInHandoffTestGroup, userIsAuthenticated = _b.userIsAuthenticated, canvasEaselHost = _b.canvasEaselHost;
    var PrototypeViewer = function () { return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(Provider, { store: store },
            React.createElement(App, null)))); };
    store.dispatch(actionCreators.setIsDownloaded(isDownloaded));
    store.dispatch(actionCreators.setShowTouchIndicators(showTouchIndicators));
    if (isFrameless) {
        store.dispatch(actionCreators.setFrameless(isFrameless));
    }
    if (isBasic) {
        store.dispatch(actionCreators.setIsBasic(isBasic));
    }
    if (initialScreen) {
        store.dispatch(actionCreators.setInitialScreen(initialScreen));
    }
    store.dispatch(actionCreators.setUserRole(userRole));
    store.dispatch(actionCreators.setCanvasEaselURLs(canvasEaselHost));
    store.dispatch(actionCreators.setIsUserAuthenticated(userIsAuthenticated));
    store.dispatch(actionCreators.setUserCompanyId(companyId));
    store.dispatch(actionCreators.setIsSuperUser(userIsSuperUser));
    store.dispatch(actionCreators.setIsUserInHandoffTestGroup(userIsInHandoffTestGroup));
    bindKeyboardShortcuts(store, areKeyboardControlsEnabled);
    addPublicAPIs(PrototypeViewer, store);
    return PrototypeViewer;
}
